var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepsJpgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1368",
    "data-name": "Group 1368",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.94,
    height: 58.469,
    viewBox: "0 0 45.94 58.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083",
    "data-name": "Rectangle 1083",
    width: 45.94,
    height: 58.469,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25596",
    "data-name": "Path 25596",
    d: "M80.236,58.469H42.875a2.317,2.317,0,0,1-2.314-2.314V2.314A2.317,2.317,0,0,1,42.875,0H73.867L82.55,8.683V56.155a2.317,2.317,0,0,1-2.314,2.314",
    transform: "translate(-36.61)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25597",
    "data-name": "Path 25597",
    d: "M0,226.554l4.515,4.008.3-4.008Z",
    transform: "translate(0 -204.488)",
    fill: "#1da890"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25598",
    "data-name": "Path 25598",
    d: "M80.236,58.469H42.875a2.317,2.317,0,0,1-2.314-2.314V2.314A2.317,2.317,0,0,1,42.875,0H73.867L82.55,8.683V56.155a2.317,2.317,0,0,1-2.314,2.314M42.875,1.129A1.186,1.186,0,0,0,41.69,2.314V56.155a1.186,1.186,0,0,0,1.185,1.185H80.236a1.186,1.186,0,0,0,1.185-1.185v-47L73.4,1.129Z",
    transform: "translate(-36.61)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25599",
    "data-name": "Path 25599",
    d: "M381.27,12.71a2.6,2.6,0,0,0,2.6,2.6h5.757L381.27,6.953Z",
    transform: "translate(-344.134 -6.276)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1082",
    "data-name": "Rectangle 1082",
    width: 32.959,
    height: 13.827,
    transform: "translate(0 8.24)",
    fill: "#2acd70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25600",
    "data-name": "Path 25600",
    d: "M91.985,130.335l.9-.667a.973.973,0,0,0,.82.586c.478,0,.73-.243.73-1.027v-3.812h1.325v3.92a1.832,1.832,0,0,1-1.883,2.064,1.988,1.988,0,0,1-1.892-1.063",
    transform: "translate(-83.026 -113.2)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25601",
    "data-name": "Path 25601",
    d: "M144.725,125.415h2.019c1.289,0,2.334.469,2.334,1.892,0,1.379-1.054,1.992-2.3,1.992h-.73v1.992h-1.325Zm1.973,2.829c.73,0,1.081-.324,1.081-.937s-.4-.838-1.117-.838h-.613v1.775Z",
    transform: "translate(-130.629 -113.2)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25602",
    "data-name": "Path 25602",
    d: "M197,127.387a2.844,2.844,0,0,1,2.866-3.082,2.536,2.536,0,0,1,1.847.766l-.694.847a1.558,1.558,0,0,0-1.108-.469c-.91,0-1.55.712-1.55,1.892,0,1.207.55,1.91,1.649,1.91a1.047,1.047,0,0,0,.631-.18v-1.009h-.973v-1.081h2.145v2.7a2.831,2.831,0,0,1-1.937.712,2.752,2.752,0,0,1-2.875-3.01",
    transform: "translate(-177.814 -112.198)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25603",
    "data-name": "Path 25603",
    d: "M155.334,322.528H130.953v-21.22h24.381ZM132.082,321.4h22.123V302.437H132.082Z",
    transform: "translate(-118.198 -271.961)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25604",
    "data-name": "Path 25604",
    d: "M136.747,410.874l7.337-7.337,2.37,2.37,6.1-6.1L160,410.874Z",
    transform: "translate(-123.428 -360.871)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25605",
    "data-name": "Path 25605",
    d: "M186.263,355.038a1.58,1.58,0,1,1-1.58-1.58,1.58,1.58,0,0,1,1.58,1.58",
    transform: "translate(-165.268 -319.031)",
    fill: "#c9c9c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsJpgIcon);
export default __webpack_public_path__ + "static/media/steps-jpg-icon.99a90dd2c51fad5e72bed36300c34025.svg";
export { ForwardRef as ReactComponent };